// Saying what went wrong, out loud and in the right order.
//
// The alert region already exists and is already empty (render.js builds it
// with the form) -- a live region added to the document at the moment of the
// error is not announced by most screen readers. Only a MUTATION of a region
// that was already there gets read.

export function clearErrors(refs) {
  refs.alert.textContent = ""
  refs.alert.classList.remove("mk-signup__alert--shown")

  Object.keys(refs.inputs).forEach((name) => {
    refs.inputs[name].removeAttribute("aria-invalid")
    if (refs.errors[name]) refs.errors[name].textContent = ""
  })

  if (refs.consent) refs.consent.removeAttribute("aria-invalid")
  if (refs.consentError) refs.consentError.textContent = ""
}

export function showError(refs, problem) {
  const field = problem.field
  const message = problem.message

  clearErrors(refs)

  refs.alert.textContent = message
  refs.alert.classList.add("mk-signup__alert--shown")

  const target = field === "consent" ? refs.consent : refs.inputs[field]
  const slot = field === "consent" ? refs.consentError : refs.errors[field]

  if (slot) slot.textContent = message

  if (target) {
    target.setAttribute("aria-invalid", "true")
    // The description is appended rather than replaced: a phone field already
    // points at its hint, and losing that to show an error would cost more than
    // the error gains.
    if (slot && slot.id) {
      const existing = (target.getAttribute("aria-describedby") || "").split(" ").filter(Boolean)
      if (existing.indexOf(slot.id) === -1) {
        target.setAttribute("aria-describedby", existing.concat(slot.id).join(" "))
      }
    }
    target.focus()
  }
}
